<template>
<div>
  <Tabs :animated="false" type="card">
    <TabPane label="签约人信息">
      <singer-info @showimg="showImg" :signInfo="signInfo"></singer-info>
    </TabPane>
    <TabPane label="合同信息">
      <contract-info v-if="isParent==1" :contractInfo="contractInfo"></contract-info>
      <sub-contract-info  v-if="isParent==0" :contractInfo="subContractInfo"></sub-contract-info>
    </TabPane>
    <TabPane label="账单信息">
      <bill v-if="isParent==1" :n="getBillKey" :parentContractFid="parentContractFid"></bill>
      <sub-bill v-if="isParent==0" :billInfo="subBillInfo"></sub-bill>
    </TabPane>
    <TabPane label="交割信息">
      <delivery v-if="isParent==1" @showimg = "showImg" :projectName="projectName" :deliverysInfo="deliverysInfo"></delivery>
      <sub-delivery v-if="isParent==0" @showimg = "showImg" :deliverysInfo="subDeliverysInfo" ></sub-delivery>
    </TabPane>
    <TabPane label="房间信息" v-if="isParent==1">
      <room-list :stockInfo="stockInfo"></room-list>
    </TabPane>
    <div slot="extra">
      <a v-if="isParent==1 && contractInfo && contractInfo.contractFilePath" target="_blank" key="'isParent'" class="tab-right" :href="contractInfo.contractFilePath">合同文本查看</a>
      <a v-if="isParent==0 && subContractInfo && subContractInfo.contractFilePath" target="_blank" key="'isSub'" class="tab-right" :href="subContractInfo.contractFilePath">合同文本查看</a>
      <a href="javascript:void(0);" class="tab-right"  @click="showProHander" v-p="{menu:'contractlist',api:'contract/getSupplyProtocolList'}">补充协议查看</a>
      <Upload
              v-if="isaudit !==1 "
              :before-upload="beforeUpload"
              :headers="setHeaders"
              :action="baseUrl+'/contract/uploadSupplyProtocol'"
              :data="getData"
              :show-upload-list="false"
              :on-success="uploadSuccess">
        <a href="javascript:;"  class="tab-right" v-p="{menu:'contractlist',api:'contract/uploadSupplyProtocol'}">上传</a>
      </Upload>
    </div>
  </Tabs>
  <div class="btn-wrap" v-if="isaudit==1">
    <Button type="primary" size="large" @click="pass">通过</Button>
    <Button type="primary" size="large" @click="dismissed">驳回 </Button>
  </div>
  <img-show :n="showImgKey" :src="imgSrc"></img-show>
  <dismissed-modal :n ="dismissedKey" :contractFid="contractId" :contractCode="contractCode" @closeTag = "closeTag"></dismissed-modal>
  <!--:value.sync="showPro"-->
  <protocol-list

    v-model="showPro"
    :contractFid="getData"></protocol-list>
</div>

</template>

<script type="text/ecmascript-6">
import { confirmAudit, getParentSignSubject, getParentContractInfo, personalContractInfo, personalBillList, getParentDeliveryState, personalDeliveryInfo, getParentStockInfo } from 'api/auditContract'
import SingerInfo from './components/SingerInfo'
import ContractInfo from './components/ContractInfo'
import Bill from './components/Bill'
import Delivery from './components/CompanyDeliveryInfo'
import roomList from './components/roomList'
import SubContractInfo from './../personalContractDetail/components/ContractInfo'
import SubBill from './../personalContractDetail/components/Bill'
import SubDelivery from './../personalContractDetail/components/PersonalDeliveryInfo'
import ImgShow from 'components/ImgShow/index'
import DismissedModal from './components/DismissedModal'
import ZUpload from '@/components/upload/index';
import ProtocolList from '../components/ProtocolList';
import { getToken } from '@/utils/auth.js';
import {getBaseUrl} from "@/utils/public";




export default {
  name:'companycontractdetail',
  created(){
    this.isaudit = this.$route.query.isaudit // 1 审核 0 详情
    this.isParent = this.$route.query.isParent // 1 主合同 0 子合同
    this.parentContractFid = this.$route.query.pid
    this.contractId = this.$route.query.id
    this.contractCode = this.$route.query.code
    this.baseUrl = getBaseUrl()
    this.initData()
  },
  activated(){
    if(this.activatedKey){
      this.isaudit = this.$route.query.isaudit // 1 审核 0 详情
      this.isParent = this.$route.query.isParent // 1 主合同 0 子合同
      this.parentContractFid = this.$route.query.pid
      this.contractId = this.$route.query.id
      this.contractCode = this.$route.query.code
      this.initData()
    }
     this.activatedKey++
  },
  components:{
    SingerInfo,
    ContractInfo,
    Bill,
    Delivery,
    roomList,
    SubContractInfo,
    SubBill,
    SubDelivery,
    DismissedModal,
    ImgShow,
    ZUpload,
    ProtocolList
  },
  computed:{
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    },
    setHeaders() {
      return {'Access-Token':getToken()}
    },
    getData() {
      return {
        contractFid: this.$route.query.id || ''
      }
    }
  },
  data () {
    return {
      activatedKey:0,
      projectName:'',
      isParent:0,
      isaudit:0,
      signInfo:null,
      contractInfo:null,
      deliverysInfo:null,
      stockInfo:null,
      subContractInfo:null,
      subBillInfo:null,
      subDeliverysInfo:null,
      parentContractFid:"",
      contractId:'',
      contractCode:'',
      showImgKey:0,
      dismissedKey:0,
      imgSrc:'',
      getBillKey:0,
      addAgreementUrl:'',
      showPro:false
    };
  },
  methods:{
    showImg(data) {
      this.imgSrc = data
      this.showImgKey++
    },
    initData(){
      getParentSignSubject(this.parentContractFid).then( res => {
        this.signInfo = res.data;
      })
      if(this.isParent==1){
        this.getParentContractInfo()
      }else{
        this.getSubContractInfo()
      }

    },
    getParentContractInfo(){

      this.getBillKey++
      getParentContractInfo(this.parentContractFid).then( res => {
        this.contractInfo = res.data;
        this.projectName = res.data.projectName;
        this.addAgreementUrl = res.data.contractFileSupplyPath;
      })
      getParentDeliveryState(this.parentContractFid).then( res => {
        this.deliverysInfo = res.data
      })
      getParentStockInfo(this.parentContractFid).then( res => {
        this.stockInfo = res.data
      })
    },
    getSubContractInfo(){
      personalContractInfo(this.contractId).then( res => {
        this.subContractInfo = res.data;
        this.addAgreementUrl = res.data.contractFileSupplyPath;
      })
      personalBillList(this.contractCode).then( res => {
        this.subBillInfo = res.data
      })
      personalDeliveryInfo(this.contractId).then( res => {
        this.subDeliverysInfo = res.data
      })
    },
    pass(){
      let data = {
        auditType:1,
        contractCode:this.contractCode,
        contractFid:this.contractId
      }
      confirmAudit(data).then( res => {
        this.$Message.success('审核通过!');
        this.closeTag()
      })
    },
    dismissed() {
      this.dismissedKey++
    },
     closeTag(){

       this.$router.push({name:'order',params:{targetTab:'2'}})
    },
    uploadSuccess(res){
      console.log(res);
      this.addAgreementUrl = res.data.contractSupplyUrl;
      this.$Message.success('补充协议上传成功');
    },
    beforeUpload (file) {
      console.log("进入beforeUpload方法")
      const isLt2M = file.size / 1024 / 1024 < 10;
      console.log(isLt2M);
      if(!isLt2M) {
        this.$Notice.error({
          desc: '上传文件大小不能大于10M,请压缩后上传' ,
          duration:0
        });
        return false;
      }
      return true;
    },
    showProHander() {
      this.showPro=true;
    }
  }
}
</script>
<style scoped>
.btn-wrap {
  left:0;
  width: 100%;
  text-align: center;
  margin-top: 36px;

}
.tab-right{
  padding: 8px 16px 16px;
}
</style>

